import {TuiCard, TuiHeaderComponent, TuiLogoComponent, TuiMainComponent, TuiNavigation} from "@taiga-ui/layout";
import {
  TuiAppearance,
  TuiAutoColorPipe,
  TuiButton,
  TuiDropdown,
  TuiDropdownDirective,
  TuiDropdownOpen,
  TuiRoot
} from "@taiga-ui/core";
import {ChangeDetectionStrategy, Component, HostListener, inject, OnInit, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TuiAvatar, TuiBadge, TuiFade} from "@taiga-ui/kit";
import {BreadcrumbComponent} from "./@shared/breadcrumb/breadcrumb.component";
import {AsyncPipe, TitleCasePipe} from "@angular/common";
import {AuthService} from "./@core/auth/auth.service";
import {AuthComponent} from "./@core/auth/auth.component";
import {CasesService} from "./@sections/cases/services/cases.service";
import {environment} from "../environments/environment";
import {ProjectEnum} from "./@core/enums/project.enum";
import {LocalStorageService} from "./@core/services/local-storage-service.service";
import {SidebarComponent} from "./@shared/side-bar/sidebar.component";
import {TuiThemeColorService} from "@taiga-ui/cdk";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TuiRoot,
    TuiDropdown,
    TuiButton,
    TuiNavigation,
    BreadcrumbComponent, AsyncPipe, AuthComponent, TuiAvatar, TuiAutoColorPipe, TitleCasePipe, TuiHeaderComponent, TuiLogoComponent, TuiDropdownOpen, TuiMainComponent, TuiDropdownDirective, TuiBadge, TuiFade, SidebarComponent, TuiAppearance, TuiCard],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private readonly theme = inject(TuiThemeColorService);
  readonly #storage: LocalStorageService = inject(LocalStorageService);
  readonly #casesService: CasesService = inject(CasesService);
  private authService: AuthService = inject(AuthService);
  public environment = environment;
  public user$ = this.authService.user$;

  public logout(): void {
    this.authService.logout();
  }

  ngOnInit() {
    this.theme.color = '#201d32';
    if (this.#storage.get('side-menu') !== undefined) {
      this.isSidebarCollapsed.set(this.#storage.get('side-menu'));
    }

    void this.#casesService.requestCases();
  }

  expanded = true;
  protected readonly ProjectEnum = ProjectEnum;

  //

  isSidebarCollapsed = signal<boolean>(true);

  changeSidebarCollapsed(isSidebarCollapsed: boolean): void {
    this.#storage.set('side-menu', isSidebarCollapsed);
    this.isSidebarCollapsed.set(isSidebarCollapsed);
  }

  screenWidth = signal<number>(window.innerWidth);

  @HostListener('window:resize')
  onResize() {
    this.screenWidth.set(window.innerWidth);
    if (this.screenWidth() <= 768) {
      this.isSidebarCollapsed.set(false);
      this.#storage.set('side-menu', this.isSidebarCollapsed());
    }
  }
}
